import { useEffect, useId, useRef } from "react";
import { createPortal } from "react-dom";
import { Clock3, FileText, X } from "lucide-react";
import kitanegoLogoWordmark from "./assets/kitanego-logo-wordmark.png";
import contactChannel from "./assets/contact-channel.png";
import type { InterfaceLanguage } from "./i18n";

export default function ContactUsDialog({ language, onClose }: { language: InterfaceLanguage; onClose: () => void }) {
  const titleId = useId();
  const closeButton = useRef<HTMLButtonElement>(null);
  const closeLabel = language === "en" ? "Close" : "Tutup";

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    closeButton.current?.focus();
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [onClose]);

  return createPortal(
    <div className="about-us-dialog contact-dialog" onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
      <article className="about-us-dialog__window contact-dialog__window" role="dialog" aria-modal="true" aria-labelledby={titleId}>
        <header className="about-us-dialog__header">
          <div className="about-us-dialog__brand">
            <img src={kitanegoLogoWordmark} alt="Kitanego" />
          </div>
          <button ref={closeButton} type="button" className="about-us-dialog__close" onClick={onClose} aria-label={closeLabel}><X /></button>
        </header>

        <div className="contact-dialog__content">
          <p className="contact-dialog__lead" id={titleId}>Contact us</p>
          <p>For account questions, wishlist support, privacy requests, supplier enquiries or general feedback, contact the Kitanego team using the address below.</p>

          <div className="contact-dialog__address">
            <img src={contactChannel} alt="Kitanego support email address" draggable="false" />
          </div>

          <div className="contact-dialog__guidance">
            <div><FileText /><span><strong>Include useful details</strong>Add your account name and a short description of what you need help with.</span></div>
            <div><Clock3 /><span><strong>Response time</strong>We aim to respond within two business days.</span></div>
          </div>
        </div>
      </article>
    </div>,
    document.body,
  );
}
